var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/nam.phamanh/Documents/Nam/git/cs/lazada/node_modules/_nunjucks-loader@2.4.9@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/evaluate/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"alime-evaluate _block\">\n  <div class=\"alime-evaluate _text\" data-evaluate=\"text\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "text"), env.opts.autoescape);
output += "</div>\n  <div class=\"alime-evaluate _actions\">\n    <div class=\"alime-evaluate _button -like\" data-evaluate=\"button\" data-evaluate-value=\"good\"></div>\n    <div class=\"alime-evaluate _button -dislike\" data-evaluate=\"button\" data-evaluate-value=\"bad\"></div>\n  </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/evaluate/tpl.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/app/extension/evaluate/tpl.html
// module id = 365
// module chunks = 0 1